(function tryReplace() {
  const btn = document.getElementById("reamaze-widget");
  console.log("intentado buscar widget");
  if (btn) {
    // ocultar SVG}
    console.log("widget encontrado")
    const iconContainer = document.getElementById("reamaze-widget-icon");
    if (iconContainer) {
      iconContainer.remove(); // 🚀 elimina completamente el <span> y su contenido (SVG)
    }
    // agregar texto si no existe
    if (!btn.querySelector(".mi-reamaze-texto")) {
      const txt = document.createElement("span");
      txt.className = "mi-reamaze-texto";
      txt.textContent = "Live Chat";
      txt.style.color = "white";
      txt.style.fontSize = "16px";
      txt.style.marginLeft = "8px";
      btn.appendChild(txt);
    }
    return; // terminado
  }
  // si no existe aún, reintenta dentro de 200 ms (y evitar loops infinitos)
  setTimeout(tryReplace, 200);
})();
